export default __webpack_public_path__ + "static/SportSupport_textlogo_inv-0bae9bbe6b038b6118ffbb84f982fdfc.png";